<template>
  <v-app>
    <vue100vh class="wrapper">
      <header class="main-header">
        <div class="header-title">
          <img class="header-logo" src="../assets/hcmWebLogo.png" />
          <span class="header-text">HCM Care</span>
          <div class="header-filler"></div>
          <v-btn
            icon
            color="white"
            :ripple="false"
            id="no-background-hover"
            to="/info"
          >
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </div>
        <div class="header-search">
          <div class="search-field-wrapper">
            <v-form @submit.prevent="doSearch()">
              <v-text-field
                class="search-text"
                dense
                solo
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                clearable
                v-model="searchTerms"
              >
              </v-text-field>
            </v-form>
          </div>
        </div>
      </header>

      <nav class="sidebar-nav">
        <div class="sidebar-header">
          <img class="header-logo" src="../assets/hcmWebLogo.png" />
          <span class="header-text">HCM Care</span>

          <div class="sidebar-search">
            <div class="search-field-wrapper">
              <v-form @submit.prevent="doSearch()">
                <v-text-field
                  class="search-text"
                  dense
                  solo
                  prepend-inner-icon="mdi-magnify"
                  background-color="white"
                  clearable
                  v-model="searchTerms"
                >
                </v-text-field>
              </v-form>
            </div>
          </div>
        </div>

        <v-list class="sidebar-selection pa-0" dense nav>
          <div class="nav-group">
            <v-list-item to="/news" value="news" link :ripple="false">
              <v-list-item-icon>
                <v-icon>mdi-text-box-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="side-nav-text"
                  >News</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </div>

          <div class="nav-group">
            <v-list-item to="/learn" value="learn" link :ripple="false">
              <v-list-item-icon>
                <v-icon>mdi-school</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="side-nav-text"
                  >Learn</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <div class="nav-sub-group pl-14">
              <v-list-item to="/my-diagnosis" link :ripple="false">
                <v-list-item-content>
                  <v-list-item-title class="side-nav-text"
                    >My Diagnosis</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <v-list-item to="/my-care" link :ripple="false">
                <v-list-item-content>
                  <v-list-item-title class="side-nav-text"
                    >My Care</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <v-list-item to="/my-family" link :ripple="false">
                <v-list-item-content>
                  <v-list-item-title class="side-nav-text"
                    >My Family</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>

          <div class="nav-group">
            <v-list-item to="/watch" value="watch" link :ripple="false">
              <v-list-item-icon>
                <v-icon>mdi-video</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="side-nav-text"
                  >Watch</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <div class="nav-sub-group pl-14">
              <v-list-item to="/provider-videos" link :ripple="false">
                <v-list-item-content>
                  <v-list-item-title class="side-nav-text"
                    >Provider Videos</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <v-list-item to="/patient-videos" link :ripple="false">
                <v-list-item-content>
                  <v-list-item-title class="side-nav-text"
                    >Patient Videos</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>

          <div class="nav-group">
            <v-list-item to="/connect" value="connect" link :ripple="false">
              <v-list-item-icon>
                <v-icon>mdi-forum</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="side-nav-text"
                  >Connect</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </div>

          <div class="nav-group">
            <v-list-item to="/info" link :ripple="false">
              <v-list-item-icon>
                <v-icon>mdi-information</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="side-nav-text"
                  >Tool Info</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
      </nav>

      <main class="main-content">
        <router-view />
      </main>

      <nav class="bottom-nav">
        <v-bottom-navigation grow class="d-flex d-sm-none">
          <v-btn to="/news" value="news">
            <span>News</span>

            <v-icon>mdi-text-box-multiple</v-icon>
          </v-btn>

          <v-btn to="/learn" value="learn">
            <span>Learn</span>

            <v-icon>mdi-school</v-icon>
          </v-btn>

          <v-btn to="/watch" value="watch">
            <span>Watch</span>

            <v-icon>mdi-video</v-icon>
          </v-btn>

          <v-btn to="/connect" value="connect">
            <span>Connect</span>

            <v-icon>mdi-forum</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </nav>
    </vue100vh>
  </v-app>
</template>

<script>
import vue100vh from "vue-100vh";

export default {
  name: "App",

  components: { vue100vh },

  data: () => ({
    searchTerms: null
  }),
  methods: {
    doSearch() {
      this.$ga.event({
        eventCategory: "Search: " + this.searchTerms,
        eventAction: "Search"
      });

      this.$router
        .push({ path: "search", query: { q: this.searchTerms } })
        .catch(() => {});
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name !== "Search") {
      this.searchTerms = null;
    }
    next();
  }
};
</script>

<style scoped>
@media (min-width: 0px) {
  .wrapper {
    display: grid;
    margin: 0;

    background-color: aqua;
    grid-template-columns: 1fr;
    grid-template-rows: 106px 1fr 56px;
    grid-template-areas:
      "main-header"
      "main-content"
      "bottom-nav";
  }
  .sidebar-nav {
    display: none;
  }
  .bottom-nav {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}

@media (min-width: 800px) {
  .wrapper {
    display: grid;
    margin: 0;

    background-color: orange;
    grid-template-columns: 280px 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: "sidebar-nav  main-content";
  }
  .main-header {
    display: none;
  }
  .sidebar-nav {
    display: flex;
    flex-direction: column;
  }
  .bottom-nav {
    display: none;
  }
}

.main-header {
  grid-area: main-header;
  background-color: rgb(18, 102, 173);
  padding: 20px 20px;
}

.sidebar-nav {
  grid-area: sidebar-nav;
  background-color: rgb(18, 102, 173);
}

.main-content {
  grid-area: main-content;
  background: linear-gradient(90deg, #a0c2de, #d199a3);
  overflow: auto;
  padding: 10px 10px;
}

.bottom-nav {
  grid-area: bottom-nav;
  background-color: rgb(242, 242, 242);
}

.header-title {
  display: flex;
  align-items: center;
}

.header-logo {
  width: 20px;
  height: 20px;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  color: rgb(255, 255, 255);
  margin-left: 8px;
}

.header-filler {
  flex-grow: 1;
}

#no-background-hover::before {
  background-color: transparent !important;
}

.header-search {
  display: flex;
}

.search-field-wrapper {
  width: 200px;
}

.sidebar-header {
  padding: 20px 20px 0px 20px;
}

.sidebar-search {
  padding-top: 20px;
}

.sidebar-selection {
  background-color: var(--v-primary-base);
  color: white;
}

.v-list-item .theme--light {
  color: white;
}

.side-nav-text {
  color: white;
}

.v-list-item--active .side-nav-text {
  font-weight: 900;
  font-size: 16px;
}

.nav-group {
  border-top: 2px solid white;
}
</style>
